<!--
 * @Author: cn1994
 * @Date: 2024-09-24 13:27:40
 * @LastEditors: cn1994
 * @LastEditTime: 2025-04-07 16:10:53
 * @Description: 按钮组件
-->
<template>
  <div class="ls-text" :style="cssVars">
    <el-tooltip v-if="!pinch" :disabled="tooltipDisabled" :effect="effect" :placement="placement">
      <div slot="content" class="max-w-[420px] max-h-[160px] overflow-auto">{{text}}</div>
      <span>{{text}}</span>
    </el-tooltip>
    <div v-else class="flex flex-col items-center">
      <div :style="pinchCssVars">{{text}}</div>
      <span class="cursor-pointer mt-[10px]" :class="toggleClass" @click="toggleHandel">{{ toggleText }} <i :class="toggleIcon"></i></span>
    </div>
  </div>
</template>

<script>

import mixin from './index.js'

export default {
  name: 'LsText',
  componentName: 'LsText',
  mixins: [mixin],
  props: {
    text: {
      type: String,
      default: ''
    },
    ellipsis: {
      type: Boolean,
      default: false
    },
    row: {
      type: Number,
      default: 1
    },
    tooltip: {
      type: Boolean,
      default: false
    },
    effect: {
      type: String,
      default: 'dark',
      validator: (val) => ['dark', 'light'].includes(val),
    },
    placement: {
      type: String,
      default: 'top-start',
      validator: (val) => ['top', 'top-start', 'top-end', 'bottom', 'bottom-start', 'bottom-end', 'left', 'left-start', 'left-end', 'right', 'right-start', 'right-end'].includes(val),
    },
    pinch: {
      type: Boolean,
      default: false
    },
    pinchRow: {
      type: Number,
      default: 10
    },
    toggleClass: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      toggle: false,
    }
  },
  computed: {
    tooltipDisabled() {
      return !this.ellipsis || !this.tooltip || this.pinch
    },
    cssVars() {
      if (!this.ellipsis || this.pinch) return null
 
      return {
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "display": "-webkit-box",
        "autoprefixer": "ignore next",
        /* autoprefixer: ignore next */
        "-webkit-line-clamp": this.row,
        "-webkit-box-orient": "vertical",
        "word-break": "break-all",
        "width": "100%"
      }
    },
    toggleText() {
      return this.toggle ? '收起' : '展开'
    },
    toggleIcon() {
      return this.toggle ? 'el-icon-arrow-up' : 'el-icon-arrow-down'
    },
    pinchCssVars() {
      if (this.toggle) return null
 
      return {
        "overflow": "hidden",
        "text-overflow": "ellipsis",
        "display": "-webkit-box",
        "autoprefixer": "ignore next",
        /* autoprefixer: ignore next */
        "-webkit-line-clamp": this.pinchRow,
        "-webkit-box-orient": "vertical",
        "word-break": "break-all",
        "width": "100%"
      }
    },
  },
  methods: {
    toggleHandel() {
      this.toggle = !this.toggle
    }
  }
}

</script>

<style lang="less" scoped>
@import url('./index.less');
</style>